import { render, staticRenderFns } from "./CandlestickChart.vue?vue&type=template&id=b35c056a"
import script from "./CandlestickChart.vue?vue&type=script&lang=js"
export * from "./CandlestickChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports